var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconYes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7834 0.434546L4.16236 7.86879L1.81617 5.23445C1.53759 4.92165 1.08731 4.92165 0.808727 5.23445C0.530148 5.54724 0.530148 6.05283 0.808727 6.36562L3.65864 9.56556C3.79757 9.72155 3.97996 9.79995 4.16236 9.79995C4.34475 9.79995 4.52715 9.72155 4.66608 9.56556L11.7909 1.56572C12.0694 1.25293 12.0694 0.74734 11.7909 0.434546C11.5123 0.121753 11.062 0.121753 10.7834 0.434546Z",
    fill: "#33AB6F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYes);
export default __webpack_public_path__ + "static/media/icon-yes.9f6a6b085a66208bf062080898dd6c4b.svg";
export { ForwardRef as ReactComponent };